import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { IInputProps } from "root/store/CajitaStore";

/**
 * Input StateFull Component
 */

class InputComponent extends React.Component<
  IInputProps & LocalizeContextProps,
  { cursor: number }
> {
  private textInput: React.RefObject<HTMLInputElement> = React.createRef();

  constructor(props: IInputProps & LocalizeContextProps) {
    super(props);
    this.state = {
      cursor: 0,
    };
    this._onChange = this._onChange.bind(this);
  }

  public componentDidUpdate(): void {
    const ref: HTMLInputElement = this.textInput.current as HTMLInputElement;

    if (
      ref.selectionStart !== this.state.cursor &&
      ref.selectionEnd !== this.state.cursor
    )
      ref.selectionStart = ref.selectionEnd = this.state.cursor;
  }

  public render(): React.ReactNode {
    if (
      !this.props.valid &&
      this.props.dirty &&
      this.props.classes[this.props.classes.length - 1] !== "error"
    )
      this.props.classes.push("error");
    else if (
      this.props.valid &&
      this.props.classes[this.props.classes.length - 1] === "error"
    )
      this.props.classes.pop();

    return (
      <div className={this.props.classContainer}>
        <input
          id={`${this.props.attributes.id}`}
          ref={this.textInput}
          value={this.props.value}
          placeholder={this.props
            .translate(`${this.props.attributes.id}`)
            .toString()}
          {...this.props.attributes}
          className={this.props.classes.join(" ")}
          onBlur={(): void => {
            if (this.props.dirty) return;
            this.props.touched(this.props);
          }}
          style={this._buildStyleToInputCard()}
          onChange={this._onChange}
          required={this.props.required}
        />
      </div>
    );
  }

  private _buildStyleToInputCard(): React.CSSProperties | undefined {
    if (this.props.rules.isCardNumber === true && this.props.card !== undefined)
      return {
        background: `url(${
          this.props.card.urlIcon
        }) 4px center / 30px no-repeat`,
      };

    return;
  }

  private _onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    let value: string = event.target.value.split(this.props.separator).join("");
    let cursor: number = event.target.selectionStart as number;

    if (
      this.props.inputPattern.test(value) &&
      value.length <= this.props.rules.maxLength
    ) {
      const arr: RegExpMatchArray | null = value.match(this.props
        .presentationPattern as RegExp);

      value = arr !== null ? arr.join(this.props.separator) : "";

      cursor =
        arr !== null &&
        arr.length > this.props.value.split(this.props.separator).length
          ? cursor + 1
          : cursor;
    } else {
      value = this.props.value;
      cursor -= 1;
    }

    this.setState({ cursor: cursor }, () => {
      if (value !== this.props.value)
        this.props.change(this.props.attributes.id, value);
    });
  }
}

const Input: React.ComponentType<
  Pick<IInputProps, Exclude<keyof IInputProps, keyof LocalizeContextProps>>
> = withLocalize<IInputProps & LocalizeContextProps>(InputComponent);

export { Input };



// WEBPACK FOOTER //
// ./src/components/Input/InputComponent.tsx